import { DEV } from "solid-js"
import { EntityTypeId } from "../../../../core/entity/EntityTypeId.enum"
import type { RNGConfig } from "../../../../core/rng/RNGConfig.type"
import { sample } from "../../../../core/rng/index"
import { freeze } from "../../../../core/util/Object"

const desertPool = [1, 1, 1, 2]
const plainsPool = [1, 1, 1, 2, 2, 3, 4]
const marshPool = [3, 4, 5, 6, 7, 7, 8, 8, 9]

if (DEV) {
  freeze(desertPool)
  freeze(plainsPool)
  freeze(marshPool)
}

export default function getEntityGrassWaveRandomBatchCount(
  etype_id: EntityTypeId,
  rng: RNGConfig,
): number {
  switch (etype_id) {
    case EntityTypeId.Desert:
      return sample(desertPool, rng)!
    case EntityTypeId.Plain:
      return sample(plainsPool, rng)!
    case EntityTypeId.Marsh:
      return sample(marshPool, rng)!
    case EntityTypeId.River:
      return sample(desertPool, rng)!
    case EntityTypeId.Sea:
      return sample(desertPool, rng)!
    case EntityTypeId.Shoal:
      return sample(desertPool, rng)!
  }
  return 1
}